import { Box, Stack, styled, useMediaQuery, useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import type { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { Footer } from '@/src/components/Footer';
import { mediumScreen } from '@/src/shared/constants/MediaQueryConstants';
import { useAppRoute } from '@/src/shared/hooks/useAppRoute';
import { selectIsCurrentConversationNew } from '@/src/store/apps/chat';
import { homePageBackgroundColor } from '@/src/styles/theme/lightThemeOptions';

import { Header } from '../../Header';
import { AppBar } from '../adminlayout/adminLayout.style';
import { AppMainContainer } from '../style';
import { AppDrawer } from './AppDrawer';

interface OuterBoxProps {
    isNewsLetterPage: boolean;
}

const StyledStack = styled(Stack)({
    width: '100%',
    flexDirection: 'column',
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: homePageBackgroundColor,
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat',
        zIndex: -1,
        pointerEvents: 'none',
    },
});

const OuterBox = styled(Box)(({ isNewsLetterPage }: OuterBoxProps) => ({
    height: '100vh',
    display: 'flex',
    flexDirection: isNewsLetterPage ? 'column' : 'row',
    overflow: isNewsLetterPage ? 'auto' : 'hidden',
}));

const DefaultLayout: FC<{ children: ReactNode }> = ({ children }) => {
    const isCurrentConversationNew = useSelector(selectIsCurrentConversationNew);
    const router = useRouter();
    const isNewsLetterPage = router.pathname === '/things-you-must-know';
    const isMobileScreen: boolean = useMediaQuery(mediumScreen);
    const theme = useTheme();
    const { isPolli, isHomePage } = useAppRoute();
    const shouldShowFooter = !isPolli && isHomePage && isCurrentConversationNew;
    return (
        <OuterBox data-testid="default-layout" isNewsLetterPage={isNewsLetterPage}>
            {isHomePage && <AppDrawer />}
            <StyledStack>
                <AppBar
                    position="static"
                    theme={theme}
                    className="homePageHeader"
                    isMobileScreen={isMobileScreen}
                >
                    <Header />
                </AppBar>
                <AppMainContainer isNewsLetterPage={isNewsLetterPage}>{children}</AppMainContainer>
                {shouldShowFooter && <Footer />}
            </StyledStack>
        </OuterBox>
    );
};

export default DefaultLayout;
